import Cookies from 'universal-cookie';

const isVeriiproDomain = () => {
  const host = process.env.REACT_APP_ALLOWED_HOST || '';
  return host.endsWith('.veriipro.com');
};

// Demo and prod are sibling subdomains of the shared apex .veriipro.com, so a
// cookie set with domain:'.veriipro.com' is a single cookie across both envs.
// Partition the auth cookie NAMES by environment so the two never collide,
// while keeping the shared domain for intra-env sharing.
const resolveEnv = () => {
  const explicit = (process.env.REACT_APP_ENV || '').trim().toLowerCase();
  if (explicit) return explicit;
  const host = (process.env.REACT_APP_ALLOWED_HOST || '').toLowerCase();
  if (!host.endsWith('.veriipro.com')) return 'development';
  if (host.startsWith('demo')) return 'demo';
  if (host.startsWith('temp')) return 'stage';
  return 'production';
};

const ENV = resolveEnv();

export const cookieName = (baseName) => (ENV === 'production' ? baseName : `${ENV}__${baseName}`);

export const TOKEN_COOKIE = cookieName('veriipro-token');
export const USER_COOKIE = cookieName('veriipro-user');
export const DEVICE_ID_COOKIE = cookieName('deviceId');

export const setCookie = (name, value, expiry = 1) => {
  const cookies = new Cookies();
  cookies.set(name, value, { path: '/' });
};

export const setCookieForCrossOrigin = (name, value) => {
  try {
    const cookies = new Cookies();
    cookies.set(name, value, {
      path: '/',
      ...(isVeriiproDomain() && { domain: '.veriipro.com' }),
      maxAge: 60 * 60 * 24
    });
  } catch (error) {
    console.error('setCookieForCrossOrigin error:', error.message);
  }
};

export const getCookie = (name) => {
  const cookies = new Cookies();
  return cookies.get(name);
};

export const removeCookie = (name) => {
  const cookies = new Cookies();
  cookies.remove(name, { path: '/' });
};

export const removeCookieForCrossOrigin = (name) => {
  try {
    const cookies = new Cookies();
    cookies.remove(name, {
      path: '/',
      ...(isVeriiproDomain() && { domain: '.veriipro.com' })
    });
  } catch (error) {
    console.error('removeCookieForCrossOrigin error:', error.message);
  }
};

export const removeAllCookie = () => {
  const cookies = new Cookies();
  cookies.remove();
};

// VTS-593: intentional no-op. A non-prod env must NEVER remove a bare cookie on
// the shared .veriipro.com apex — there the bare name is PROD's live session,
// not an orphan, so removing it wipes a logged-in prod user. Env-name
// partitioning already isolates demo (`stage__*`/`demo__*`) from prod (bare),
// so no sweep is needed or safe. Kept exported so callers' imports stay valid.
export const clearLegacyBareCookies = () => {};
